import React from "react";
import { Box, CircularProgress } from "@mui/material";

/**
 * Shared loading spinner used as Suspense fallback across all routers.
 *
 * @param {Object} props
 * @param {boolean} [props.fullScreen=false] - When true, uses height="100vh" (AppRouter).
 *                                              Default uses minHeight="50vh" (sub-routers).
 */
const PageLoader = ({ fullScreen = false }) => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    {...(fullScreen ? { height: "100vh" } : { minHeight: "50vh" })}
  >
    <CircularProgress />
  </Box>
);

export default PageLoader;
